<template>
	<div id="baikelist">
		<!--<swiper :options="swiperOption" ref="swiperOption" v-if="list3.length>0">-->
			<!--<swiper-slide v-for="item of list3" :key="item.id">-->
				<!--<img :src="item.images.image_url" width="100%" height="auto" />-->
			<!--</swiper-slide>-->
			<!--<div class="swiper-pagination"  slot="pagination"></div>-->
		<!--</swiper>-->
		<div class="container padding50">

			<div class="index-con-wd bklist index-con-tit">
				<h2>热门艺人排行</h2>
				<i></i>
				<h4>POPULAR ARTIST RANKINGS</h4>
			</div>
			<div class="clearfix"></div>

			<div class="bk-list-pic1">
				<ul>
					<li v-for="item in list.slice(0,6)" :key="item.key">
						<router-link :to="'/baikecontent/'+item.id">
							<img v-bind:src='item.picture' width="184" height="274" v-bind:alt="item.name" />
							<div class="bklist-wd bklist2">
								<div class="float-left" style="width:60px;padding-left: 10px;">{{item.name}}</div>
								<div class="float-right" style="width:70px; padding-right: 10px;">
									<i style="transform: scale(0.5);"></i>
									<span style="padding-left: 20px;">{{item.hot_number}}</span>
									<div class="clearfix"></div>
								</div>
								<div class="clearfix"></div>
							</div>
						</router-link>
					</li>
					<div class="clearfix"></div>
				</ul>
			</div>

			<!-- swiper -->
			<swiper :options="swiperOption2" ref="swiperOption2" v-if="list1.length>0">
				<swiper-slide v-for="(item,i) of list.slice(7,18)" :key="item.key">
					<router-link :to="'/baikecontent/'+item.id">
					<div class="bk-new" style="margin-top: 50px;">
						<div class="thumb" style="width: 80px;height: 80px;overflow: hidden;float: left;">
							<img class="float-left" :src="item.picture" :onerror="errorImg" width="80" height="auto">
						</div>
						<div class="float-left" style="margin-top: 14px; color: #333;margin-left: 40px;">
							<p>{{item.name}}</p>
							<p style="padding-left: 20px;padding-top: 10px"><i class="hot-icon" style="transform: scale(0.5);"></i>{{item.hot_number}}</p>
						</div>
						<div class="clearfix"></div>
					</div>
					</router-link>
				</swiper-slide>
			</swiper>

		</div>

		<div class="container ">
			<div class="search-tag">

				<div class="tag-con3">

					<div class="float-left tag-left">性别</div>
					<div class='float-left tag-right'>
						<el-radio-group v-model="sex" size="small" border=false @change="getsearch">
							<el-radio-button label="" >不限</el-radio-button>
							<el-radio-button label="1">男</el-radio-button>
							<el-radio-button label="2">女</el-radio-button>

						</el-radio-group>

					</div>
					<div class="clearfix"></div>
				</div>

				<div class="tag-con3">
					<div class="float-left tag-left">身高</div>
					<div class='float-left tag-right'>
						<el-radio-group v-model="stature" size="small" border=false @change="getsearch">
							<el-radio-button label="">不限</el-radio-button>
							<el-radio-button label="0,150">150cm以下</el-radio-button>
							<el-radio-button label="150,160">150cm-160cm</el-radio-button>
							<el-radio-button label="160,170">160cm-170cm</el-radio-button>
							<el-radio-button label="170,180">170cm-180cm</el-radio-button>
							<el-radio-button label="180,190">180cm-190cm</el-radio-button>
							<el-radio-button label="190,250">190cm以上</el-radio-button>
						</el-radio-group>

					</div>
					<div class="clearfix"></div>
				</div>
				<div class="tag-con3">
					<div class="float-left tag-left">脸型</div>
					<div class='float-left tag-right'>
						<el-radio-group v-model="feature" size="small" border=false @change="getsearch">
							<el-radio-button label="">不限</el-radio-button>
							<el-radio-button label="1">菱形脸</el-radio-button>
							<el-radio-button label="2">鹅蛋脸</el-radio-button>
							<el-radio-button label="3">国字脸</el-radio-button>
							<el-radio-button label="4">瓜子脸</el-radio-button>
							<el-radio-button label="5">圆形脸</el-radio-button>
							<el-radio-button label="6">方形脸</el-radio-button>
							<el-radio-button label="7">三角脸</el-radio-button>
						</el-radio-group>
					</div>
					<div class="clearfix"></div>
				</div>
				<div class="tag-con3">
					<div class="float-left tag-left">职业</div>
					<div class='float-left tag-right'>
						<el-radio-group v-model="vocation" size="small" border=false @change="getsearch">

							<el-radio-button label="">不限</el-radio-button>
							<el-radio-button label="1">演员</el-radio-button>
							<el-radio-button label="2">模特</el-radio-button>
							<el-radio-button label="3">歌手</el-radio-button>
							<el-radio-button label="4">导演</el-radio-button>
							<el-radio-button label="5">副导演</el-radio-button>
							<el-radio-button label="6">编剧</el-radio-button>
							<el-radio-button label="7">制片</el-radio-button>
							<el-radio-button label="8">主持人</el-radio-button>
						</el-radio-group>

					</div>
					<div class="clearfix"></div>
				</div>
				<div class="tag-con3">
					<div class="float-left tag-left">特长</div>
					<div class='float-left tag-right'>
						<el-checkbox-group v-model="tag" border=false>
							<el-checkbox-button v-for="item in tags" :label="item.key" :key="item.key" @change="choose(item.key)">
								{{item.value}}
							</el-checkbox-button>

						</el-checkbox-group>
					</div>
					<div class="clearfix"></div>
				</div>
				<div class="tag-con3">
					<div class="float-left tag-left">标签</div>
					<div class='float-left tag-right'>
						<el-checkbox-group v-model="label" border=false>
							<el-checkbox-button v-for="item in labels" :label="item.key" :key="item.key" @change="choose2(item.key)">
								{{item.value}}
							</el-checkbox-button>
						</el-checkbox-group>
					</div>
					<div class="clearfix"></div>
				</div>

				<!--<div style="width: 200px; margin: 20px auto;"><input type="button" class="bk-search-btn" value="GO" @click="getsearch" /></div>-->

			</div>
			<div class="nav-bk-list">
				<ul>
					<li v-for="item in list2" :key="item.id">
						<div class="list-pic-sty">
							<!-- <div class=""> -->
							<router-link :to="'/baikecontent/'+item.id" target="_blank">
								<img v-bind:src="item.picture" width="100%" height="auto" />

								<div class="bk-pic-con" style="background: rgba(0,0,0,0.5);height:429px;margin-top:-429px ">
									<div style="height: 80px;"></div>
									<div class="bk-pic-wd">
										<p>性别：{{item.sex}}</p>
										<p>身高：{{item.stature}}cm</p>
										<p>体重：{{item.weight}}kg</p>
										<p>特长：<span :key="item2.id" v-for="item2 in item.perf_keyword" v-if="item2.state===1">{{item2.tag}}/</span></p>
										<p>标签：<span :key="item2.id" v-for="item2 in item.perf_keyword" v-if="item2.state===2">{{item2.tag}}/</span></p>
									</div>
								</div>
							</router-link>
							<!-- </div> -->
							<div class="list-pic-foo">
								<span class="float-left" style="margin-top: 8px;margin-left: 20px;">
									<p>{{item.name}}</p>
									<p style="color: #888;font-size: 14px">{{item.english_name}}</p>
								</span>
								<div class="float-right "></div><!-- 人气 -->
								<div class="clearfix"></div>
							</div>
							<div class="clearfix"></div>
						</div>
						<div class="clearfix"></div>
					</li>


					<div class="clearfix"></div>
				</ul>


			</div>
			<v-page :total-row="totalRow" align="center" :page-size-menu="false" :info="false" @page-change="pageChange" v-if="this.list2 !== undefined"></v-page>
			<div v-else="list !== undefined" class="empty">
				<img src="../assets/images/wuxinxi_img.png">
			</div>
		</div>
	</div>
</template>
<script>
// 	import {
// 		swiper,
// 		swiperSlide
// 	} from 'vue-awesome-swiper'
	import Axios from 'axios'
	import storage from '../storage/storage.js'
	import pageNation from './pageNation'

	export default {
		data() {
			return {
				errorImg: 'this.src="' + require('../assets/mrimg.png') + '"', //未上传时显示默认图片
				info: {},
				totalRow: 100,
				pageArr: [],
				pageNum: 1,
				column_description: '',
				column_keywords: '',
				column_title: '',
				sex: '',
				stature: '',
				feature: '',
				vocation: '',
				tag: ['0'],
				tags: [{
						'key': '0',
						'value': '不限'
					},
					{
						'key': '1',
						'value': '唱歌'
					},
					{
						'key': '2',
						'value': '跳舞'
					},
					{
						'key': '3',
						'value': '武术'
					},
					{
						'key': '4',
						'value': '骑马'
					},
					{
						'key': '5',
						'value': '乐器'
					},
					{
						'key': '6',
						'value': '方言'
					},
					{
						'key': '7',
						'value': '外语'
					},
					{
						'key': '8',
						'value': '主持'
					},
					{
						'key': '9',
						'value': '驾驶'
					},
					{
						'key': '10',
						'value': '书画'
					}


				],
				label: ['0'],
				labels: [
					{
						'key': '0',
						'value': '不限'
					},
					{
						'key': '11',
						'value': '特型'
					},
					{
						'key': '12',
						'value': '朴实'
					},
					{
						'key': '13',
						'value': '谐星'
					},
					{
						'key': '14',
						'value': '胖咖'
					},
					{
						'key': '15',
						'value': '丑咖'
					},
					{
						'key': '16',
						'value': '痞气'
					},
					{
						'key': '17',
						'value': '反派'
					},
					{
						'key': '18',
						'value': '中性'
					},
					{
						'key': '19',
						'value': '妩媚'
					},
					{
						'key': '20',
						'value': '性感'
					},
					{
						'key': '21',
						'value': '知性'
					},
					{
						'key': '22',
						'value': '御姐'
					},
					{
						'key': '23',
						'value': '帅气'
					},
					{
						'key': '24',
						'value': '大叔'
					},
					{
						'key': '25',
						'value': '霸道'
					},
					{
						'key': '26',
						'value': '成熟'
					},
					{
						'key': '27',
						'value': '小鲜肉'
					},
					{
						'key': '28',
						'value': '阳光'
					},
					{
						'key': '29',
						'value': '暖男'
					},
					{
						'key': '30',
						'value': '老戏骨'
					},
					{
						'key': '31',
						'value': '喜剧性'
					},
					{
						'key': '32',
						'value': '硬汉'
					},
					{
						'key': '33',
						'value': '文艺范'
					},
				],
				keyword: [],
				list: [],
				list1: [],
				list2: [],
				list3: [],
				seoList: {
					column_title: '艺人百科'
				},
				swiperOption: {
					loop:true,
					// notNextTick: true,
					slidesPerView:1,
					autoplay: {
						delay:3000,
					},
					autoplayDisableOnInteraction: false,
					speed: 2000,
					// spaceBetween:30,
					observer:true,//修改swiper自己或子元素时，自动初始化swiper
					observeParents:true,//修改swiper的父元素时，自动初始化swiper
                    pagination: {
                        el: '.swiper-pagination',
                        clickable: true,
                        type: "bullets"
                    }
				},
				swiperOption2: {
					autoplay: {
						delay:2000,
					},
					speed: 1000,
					loop: true,
					slidesPerView: 4,
					autoplayDisableOnInteraction: false,
					observer:true,//修改swiper自己或子元素时，自动初始化swiper
					observeParents:true,//修改swiper的父元素时，自动初始化swiper
				}


			}

		},
		components: {
// 			swiper,
// 			swiperSlide,
			pageNation
		},
		metaInfo() {
			return {
				title: this.seoList.column_title  + '-打造影视行业优秀的资源聚合服务平台'  || '',
				meta: [{
						name: 'keywords',
						content: this.seoList.column_keywords
					},
					{
						name: 'description',
						content: this.seoList.column_description
					}
				]
			}
		},
// 		computed: {
// 			swiper () {
// 				return this.$refs.swiperOption.swiper
// 			}
// 		},
		methods: {
			getSeo() {
				let seoApi = 'http://api.yopoo.cn/api/v1/perfsearch'
				this.$http.get(seoApi)
					.then((res) => {
						this.seoList = res.body.metas
						this.column_title = this.seoList.column_title
						this.column_keywords = this.seoList.column_keywords
						this.column_description = this.seoList.column_description
					}, err => {
						console.log(err)
					})
			},
			choose(e) { //判断点击状态
				if (e == 0) { //判断e=0的情况来增加选中结果
					this.tag = ['0'] //点击不限则清空tag数组，取消其他选项
				}

				if (e != 0) {
					for (var i = 0; i < this.tag.length; i++) {
						if (this.tag[i] == 0) { //在this.tag中如果i=0
							this.tag.splice(this.tag[i], 1) //将等于0的值从this.tag数组中删掉
						}
					}
				}
				this.getsearch()
			},
			choose2(e) { //判断点击状态
				if (e == 0) { //判断e=0的情况来增加选中结果
					this.label = ['0']
				}
				if (e != 0) { //判断e！=0的情况
					for (var i = 0; i < this.label.length; i++) {
						if (this.label[i] == 0) { //在this.label中如果i=0
							this.label.splice(this.label[i], 1) //将等于0的值从this.label数组中删掉
						}
					}
				}
				this.getsearch()
			},
			renderList(value) { //分页传参函数
				this.pageNum = value;
				this.requestData2();
			},
			requestData() {
				var api = 'http://api.yopoo.cn/api/v1/hotactor&page=1&count=18'; //艺人排行接口
				this.$http.get(api).then((response) => {

						this.list = response.body
					},
					err => {
						console.log(err)
					}
				)
			},
			requestData1() {
				var api = 'http://api.yopoo.cn/api/v1/newuser?id=20'; //映派会员接口
				this.$http.get(api).then((response) => {

						this.list1 = response.body
					},
					err => {
						console.log(err)
					}
				)
			},
			pageChange(pInfo) {
				pInfo.pageSize = 12 //显示count数量
				this.pageNum = pInfo.pageNumber //页码
				this.info = pInfo
				this.$http.get('http://api.yopoo.cn/api/v1/perfsearch?sex=' + this.sex + '&feature=' + this.feature + '&stature=' +
					this.stature + '&keyword=' + this.keyword + '&vocation=' + this.vocation + '&page=' + this.pageNum + '&count=' +
					this.info.pageSize + '&sort=esc' +
					'&order=id').then((res) => {
                    window.scrollTo(0,0)

                    this.list2 = res.data.data
					this.pageArr = res.data.pagination //返回
					this.totalRow = res.data.pagination.total - 12
				}, (err) => {
					console.log(err)
				})

			},
			requestData2() {
				var api = 'http://api.yopoo.cn/api/v1/perfsearch'; //默认艺人列表请求数据接口
				this.$http.get(api, {
					params: {
						page: this.pageNum,
						count: 12,
					}
				}).then((res) => {
						this.list2 = res.body.data
					},
					err => {

						console.log(err)
					}
				)
			},
			requestData3() {
				var api3 = 'http://api.yopoo.cn/api/v1/homeshow?property=3&count=3' //轮播图接口
				this.$http.get(api3).then((response) => {

						this.list3 = response.body
					},
					err => {
						console.log(err)
					}
				)
			},

			getsearch() {
				if (this.tag == '0' && this.label == '0') { //判断如果tag和label的值都为0，则this.keyword字段为空
					this.keyword = ''
					// console.log('1-->',this.keyword)
				}
				if (this.tag == '0') {
					this.keyword = this.label
				}
				if (this.label == '0') {
					this.keyword = this.tag
				} else {
					this.keyword = this.tag.concat(this.label)
					// console.log('2-->',this.keyword)
				}
				// console.log('3-->',this.keyword)
				var api = 'http://api.yopoo.cn/api/v1/perfsearch?sex=' + this.sex + '&feature=' + this.feature + '&stature=' +
					this.stature + '&keyword=' + this.keyword + '&vocation=' + this.vocation + '&page=' + this.pageNum + '&count=' +
					this.info.pageSize + '&sort=esc' +
					'&order=id'
				this.$http.get(api).then((res) => {
					// console.log(res)
					this.list2 = res.body.data
					this.totalRow = res.data.pagination.total

				}, err => {
					console.log(err)
				})
			}

		},
		mounted() {

			this.requestData(); //艺人排行接口
			this.requestData1(); //映派会员接口
			this.requestData3(); //轮播图接口
			this.getSeo()


		}
	}
</script>
<style>
	div.v-pagination.v-pagination--center {
		margin: 20px 0;
	}

	#demo {

		overflow: hidden;

		width: 1200px;
		/* height: 368px; */
	}

	#demo img {
		border: 3px solid #F2F2F2;
	}

	#indemo {
		width: 8000%;
	}
	.hot-icon{
		background: url(http://yopoo.oss-cn-beijing.aliyuncs.com/icon.png) no-repeat;
		position: absolute;
		clip: rect(0px, 158px, 40px, 130px);
		width: 305px;
		height: 156px;
		margin-left: -160px;
		margin-top: -38px;
	}

</style>



// WEBPACK FOOTER //
// src/components/Baike.vue